module.exports = __webpack_public_path__ + "img/question-icon-2.57356123.png";